import { Input } from "../Input";
import { TextArea } from "../Textarea";
import { Button, ButtonAdd } from "@/components/ui/button";
import SectionItem from "./SectionItem";
import { useCreateMenu } from "@/hooks/menu/useCreateMenu";
import { Menu } from "@/redux/services/menu/menu.type";
import { useState } from "react";

interface Props {
  item?: Menu;
  isEdit?: boolean;
  isLoad?: boolean;
}

const MenuForm = ({ item, isEdit, isLoad }: Props) => {
  const {
    register,
    onSubmit,
    errors,
    isLoading,
    fields,
    append,
    control,
    menuSectionsLength,
    menuItemOptions,
    setValue,
    getValues,
    setError,
    appendSection,
    removeSection,
    watch,
  } = useCreateMenu(isEdit, item);

  const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(
    null
  );

  const handleAccordionChange = (index: number) => {
    setOpenAccordionIndex(openAccordionIndex === index ? null : index);
  };

  if (isLoad) {
    // return form skeleton
    return (
      <div className="space-y-5">
        <div className="animate-pulse h-10 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-40 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-10 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-10 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-10 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-10 bg-slate-200 rounded"></div>
        <div className="animate-pulse h-5 bg-slate-200 w-32"></div>
        <div className="flex justify-end">
          <div className="animate-pulse h-10 bg-slate-200 w-40"></div>
        </div>
      </div>
    );
  }
  return (
    <form onSubmit={onSubmit}>
      <div className="mb-5">
        <Input
          label="Titre du menu"
          type="text"
          id="title"
          placeholder="Titre du menu"
          {...register("title")}
          error={errors?.title}
          defaultValue={item?.title}
          required
        />
      </div>

      <div className="mb-5">
        <TextArea
          label="Description"
          placeholder="Description  du menu"
          id="descriptionMenu"
          {...register("description")}
          error={errors?.description}
          defaultValue={item?.description}
        />
      </div>

      {fields?.map((_, index) => (
        <SectionItem
          key={index}
          index={index}
          register={register}
          errors={errors}
          control={control}
          menuSectionsLength={menuSectionsLength}
          section={item?.menuSections[index]}
          isOpen={openAccordionIndex === index}
          handleAccordionChange={handleAccordionChange}
          menuItemOptions={menuItemOptions}
          setValue={setValue}
          getValues={getValues}
          isEdit={isEdit}
          setError={setError}
          menuId={item?.id}
          appendSection={appendSection}
          removeSection={removeSection}
          watch={watch}
        />
      ))}

      <div className="mb-14">
        <ButtonAdd label="Ajouter une section" type="button" onClick={append} />
      </div>
      <div className="flex justify-end">
        <Button isLoading={isLoading}>Enregistrer le menu</Button>
      </div>
    </form>
  );
};

export default MenuForm;
